import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import { ScrollTrigger } from "../libraries/gsap"
export default class ShopAll extends Component {
  constructor(obj) {
    super(obj)

    this.productGrid = qs("#product-grid", this.el)
    this.loadMoreBtn = qs(".shop-all-load-more", this.el)
    this.ctaWrapper = qs(".cta-wrapper", this.el)
    this.filtersBtn = qs(".shop-all-filter", this.el)
    this.filtersWrapper = qs(".filters-wrapper", this.el)
    this.filtersBg = qs(".filters-background", this.el)
    this.filterForm = qs("#collection-filters-form", this.el)
    this.productCount = qs(".product-count", this.el)

    this.filterInnerBg = qs(".filters-inner-bg", this.el)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const title = qsa(".title .char-1", this.el)
    const productCards = qsa(".product-card", this.el)

    gsap.from(title, {
      y: "100%",
      autoAlpha: 0,
      duration: 1.2,
      stagger: 0.05,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(productCards, {
      autoAlpha: 0,
      y: 100,
      duration: 1.2,
      stagger: 0.05,
      scrollTrigger: {
        trigger: productCards,
        start: "top bottom",
      },
    })

    if (this.ctaWrapper) {
      gsap.from(this.ctaWrapper, {
        autoAlpha: 0,
        y: 100,
        duration: 1.2,
        scrollTrigger: {
          trigger: this.ctaWrapper,
          start: "top bottom",
        },
      })
    }

    gsap.set(this.el, { autoAlpha: 1 })

    this.filterInnerBg.style.height = bounds(this.filterForm).height + 30 + "px"
  }

  resize() {
    this.filterInnerBg.style.height = bounds(this.filterForm).height + 30 + "px"
  }

  on() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener("click", this.loadMore)
    }

    if (this.filtersBtn) {
      this.filterForm.addEventListener("change", this.onFormChange)
      this.filtersBg.addEventListener("click", this.toggleFilter)
      this.filtersBtn?.addEventListener("click", this.toggleFilter)
    }
  }

  onFormChange = () => {
    const url = new URL(this.filterForm.dataset.url, window.location.origin)
    const params = new URLSearchParams(new FormData(this.filterForm))

    url.search = params.toString()

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const newGrid = doc.getElementById("product-grid")
        const newButton = doc.querySelector("#load-more")

        const newFilterCounts = doc.querySelectorAll(".filter-count")
        const filterCounts = qsa(".filter-count", this.el)

        const newProductCount = doc.querySelector(".product-count")

        this.productCount.innerHTML = newProductCount.innerHTML

        newFilterCounts.forEach((newCountEl, i) => {
          if (filterCounts[i]) {
            filterCounts[i].innerHTML = newCountEl.innerHTML
          }
        })

        if (newGrid) {
          this.productGrid.innerHTML = newGrid.innerHTML
          history.replaceState(null, "", url) // Update the URL in the browser
        }

        if (newButton) {
          this.ctaWrapper.style.display = "block"
          this.loadMoreBtn.dataset.nextUrl = newButton.dataset.nextUrl
          this.loadMoreBtn.textContent = "Load more"
        } else {
          this.ctaWrapper.style.display = "none"
        }

        this.renderer.smooth.update()
        ScrollTrigger.update()
      })
      .catch(err => {
        console.error("Error loading filtered products:", err)
      })
  }

  toggleFilter = () => {
    this.filtersWrapper.classList.toggle("active")
    this.filtersBg.classList.toggle("active")
    this.filtersBtn.classList.toggle("active")
  }

  loadMore = async e => {
    const nextUrl = this.loadMoreBtn.dataset.nextUrl
    if (!nextUrl) return

    this.loadMoreBtn.textContent = "Loading..."

    try {
      const response = await fetch(nextUrl)
      const text = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(text, "text/html")

      const newProducts = doc.querySelectorAll(".product-card")
      const newButton = doc.querySelector("#load-more")

      gsap.from(newProducts, {
        autoAlpha: 0,
        y: 100,
        duration: 1.2,
        stagger: 0.05,
      })

      newProducts.forEach(product => this.productGrid.appendChild(product))

      if (newButton) {
        this.ctaWrapper.style.display = "block"
        this.loadMoreBtn.dataset.nextUrl = newButton.dataset.nextUrl
        this.loadMoreBtn.textContent = "Load more"
      } else {
        this.ctaWrapper.style.display = "none"
      }

      this.renderer.smooth.update()
    } catch (err) {
      console.error("Load more failed", err)
      this.loadMoreBtn.textContent = "Error"
    }
  }
}
